import Despesa from './Despesa';

export default Despesa;